import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { FormResponsesPage } from "@/features/forms/FormResponsesPage";

const search = z.object({
  review: z.enum(["all", "new", "reviewed", "assigned", "done"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/forms/$form/responses")({
  validateSearch: search,
  component: Page,
});

function Page() {
  const { form } = Route.useParams();
  return <FormResponsesPage slug={form} search={Route.useSearch()} />;
}
